import React from "react";
import { AnalyticsPage, AnalyticsCard, StatPill } from "./analyticsShared";

export default function AIAnalytics() {
    return (
        <AnalyticsPage
            endpoint="/admin/analytics/ai"
            testId="admin-analytics-ai"
            overline="Analytics"
            title="AI Usage"
            render={(d) => (
                <>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
                        <StatPill label="Briefs today" value={d.briefs_today} testId="ai-today" />
                        <StatPill label="Briefs (7d)" value={d.briefs_week} tone="sky" testId="ai-week" />
                        <StatPill label="AI success rate" value={`${d.ai_success_rate}%`} tone="emerald" sub={`${d.briefs_ready} ready · ${d.briefs_failed} failed`} testId="ai-success" />
                        <StatPill label="Avg triage score" value={d.avg_triage_score} tone="violet" sub={`${d.triage_completed} briefs triaged`} testId="ai-triage" />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <AnalyticsCard title="Most common triage labels" subtitle="AI-generated tags on incoming briefs" rows={d.top_labels} labelKey="label" tone="violet" testId="ai-labels" />
                        <AnalyticsCard title="Top role categories" rows={d.top_role_categories} labelKey="category" tone="emerald" testId="ai-categories" />
                    </div>
                </>
            )}
        />
    );
}
